import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItemCheckbox } from 'components/Dropdown2';

const messages = defineMessages({
  label: {
    id: 'schedules.instructors-filter.label',
    defaultMessage: 'Staff',
  },
  instructorNotSet: {
    id: 'schedules.instructors-filter.no-instructor-set',
    defaultMessage: 'No staff set',
  },
  selectedOptions: {
    id: 'schedules.instructors-filter.selected-options',
    defaultMessage: '{firstOption} {selectedInstructors, select, 0 {} other {+ {selectedInstructors}} }',
  },
});

const ScheduleBoardInstructorsFilter = ({ instructors, selectedInstructors, updateSelection }) => {
  const intl = useIntl();

  const formattedInstructors = options =>
    options.map(({ id, firstName, lastName }) => ({
      id,
      name: lastName ? `${firstName} ${lastName}` : firstName,
    }));

  const completeOptions = !instructors.length
    ? []
    : [
        ...[
          { id: null, name: intl.formatMessage(messages.instructorNotSet) },
          ...formattedInstructors(instructors),
        ].map(({ id, name }) => {
          return {
            label: name,
            value: id,
            match: `${id} ${name}`,
          };
        }),
      ];

  const completeSelectedInstructors = completeOptions.filter(({ value }) => selectedInstructors.includes(value));

  return (
    <Dropdown
      multiselect
      autocomplete
      closeOnSelect={false}
      options={completeOptions}
      selectedOption={{
        label: selectedInstructors.length
          ? intl.formatMessage(messages.selectedOptions, {
              firstOption: completeSelectedInstructors[0].label,
              selectedInstructors: selectedInstructors.length - 1,
            })
          : '',
      }}
      dataCypress="schedule-board-instructors-filter"
      disabled={!instructors.length}>
      <DropdownToggle label={messages.label} />
      <DropdownMenu>
        {data =>
          data.map(({ option, isHighlighted, ref }) => {
            const { label, value } = option;
            return (
              <DropdownItemCheckbox
                key={value}
                ref={ref}
                onClick={checked => {
                  const updatedArr = checked
                    ? selectedInstructors.concat(value)
                    : selectedInstructors.filter(opt => opt !== value);
                  updateSelection(updatedArr);
                }}
                isHighlighted={isHighlighted}
                isChecked={selectedInstructors.includes(value)}>
                {label}
              </DropdownItemCheckbox>
            );
          })
        }
      </DropdownMenu>
    </Dropdown>
  );
};

ScheduleBoardInstructorsFilter.propTypes = {
  instructors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    })
  ),
  selectedInstructors: PropTypes.arrayOf(PropTypes.number),
  updateSelection: PropTypes.func,
};

export default ScheduleBoardInstructorsFilter;
